import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "components/custom_select_adv/custom_select_adv";
import "./destination_city_container.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));